export const familiarization = [
    {
        id: 1,
        Title: "Familiarization Programme",
        PDF: "https://educomp.com/Data/familiarization-programme.pdf",
        isActive: 1
    }
];